module.exports = __webpack_public_path__ + "static/media/Analytics.fe4bc915.png";